export default __webpack_public_path__ + "c66902fdfd3358faa8ea1c8a4ffc5451.svg";